import * as DateUtils from '~/utils/date.js';

export default {

    data(){
        return {


        }
    },
    computed:{
    },
    methods: {
        ...DateUtils
    }
}